import { useNavigate } from "react-router-dom";
import LayoutMain from "../../shared/layouts/LayoutMain/LayoutMain";
import { BCButton, BCPageRedirect } from "../../shared/styled/global.styled";

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <LayoutMain idPage="notFound" titlePage={false}>
      <BCPageRedirect>
        <h1>No se pudo encontrar la página que buscas.</h1>
        <p>Valida la url que ingresaste o ve al inicio</p>
        <BCButton
          type="button"
          className="bc-button-primary bc-button-small"
          onClick={() => navigate("/")}
        >
          Ir al inicio
        </BCButton>
      </BCPageRedirect>
    </LayoutMain>
  );
};

export default NotFound;
